import { render, staticRenderFns } from "./expert.vue?vue&type=template&id=cf2dda5c&scoped=true"
import script from "./expert.vue?vue&type=script&lang=js"
export * from "./expert.vue?vue&type=script&lang=js"
import style0 from "./expert.vue?vue&type=style&index=0&id=cf2dda5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2dda5c",
  null
  
)

export default component.exports